// The last organization the reader opened.
//
// This is navigation convenience only. The remembered slug is checked against
// current /v1/me memberships before it is used.

const LAST_WORKSPACE_KEY = "cs.workspace-last";

export function rememberWorkspace(slug: string): void {
  try {
    localStorage.setItem(LAST_WORKSPACE_KEY, slug);
  } catch {
    // Storage is unavailable in some privacy modes. `/` then falls back to
    // the directory, which is a fine place to land.
  }
}

export function recallWorkspace(): string {
  try {
    return localStorage.getItem(LAST_WORKSPACE_KEY) ?? "";
  } catch {
    return "";
  }
}
